import React, { useEffect, useState } from "react";

import HTopbar from '../hooks/HomeTopBar';
import 'bootstrap/dist/css/bootstrap.min.css';


import { getPublicWebRate } from '@/lib/api/WebRate'



const MainHomePage = () => {

  const [rates, setRates] = useState([]);


  useEffect(() => {
    const fetchRates = async () => {
      try {
        const res = await getPublicWebRate(); // should return latest 5
        setRates(res || []);
      } catch (err) {
        console.error("Error fetching web rates:", err);
      }
    };
    fetchRates();
  }, []);
  return (
    <div
      style={{
        ...outerWrapperStyle,
        backgroundColor: "#9e4700ff",
      }}
    >      <HTopbar />

      <div
        style={{
          ...pageWrapperStyle

        }}
      >

        <section
          id="matchup"
          style={{
            ...sectionStyle,
            backgroundImage: `url('/images/home/home.jpg?refresh=${Date.now()}')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container-fluid px-3 px-md-5 text-center text-md-start">
            <h1
              className="display-4"
              style={{ fontSize: "100px", fontWeight: "900", color: "#fff" }}
            >
              MatchUp
            </h1>

            <p className="lead" style={{ fontSize: "25px", color: "#fff" }}>
              MatchUp is an app that helps you find people to play<br />
              sports with. Whether you're into basketball, tennis, or just<br />
              want a workout buddy, it matches you based on your<br />
              schedule, skill level, and location.
            </p>

            {/* Buttons */}
            <div className="mt-4 d-flex gap-3">
              <a
                href="/login"
                className="btn btn-lg d-flex align-items-center gap-2"
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  backgroundColor: "#d42b0eff",
                  borderColor: "#ff9b54",
                  color: "#fff",
                }}
              >
                Join Now <i className="bi bi-arrow-up-right"></i>
              </a>

              <a
                href="#how-it-works"
                className="btn btn-outline-light btn-lg"
                style={{ fontSize: "20px", fontWeight: "600" }}
              >
                Explore How it Works
              </a>
            </div>
          </div>
        </section>

        <section
          id="how-it-works"
          style={{
            ...sectionStyleAlt,
            padding: "50px 0",
            backgroundColor: "#9e4700ff", // Updated background
          }}
        >
          <div
            className="container-fluid px-3 px-md-5 text-center d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "400px", color: "#fff" }}
          >
            <h2
              className="h2 text-center"
              style={{ fontSize: "100px", fontWeight: "900" }}
            >
              How MatchUp works?
            </h2>

            <p className="text-center" style={{ fontSize: "25px" }}>
              Getting started with MatchUp is easy. Just follow
              <br />
              these 3 simple steps:
            </p>

            {/* Three image containers */}
            <div className="d-flex justify-content-center align-items-start mt-4 gap-4 flex-wrap">
              <div className="step-container text-center position-relative" style={{ width: "220px" }}>
                {/* Number badge */}
                <div
                  style={{
                    position: "absolute",
                    top: "-30px",
                    left: "-30px",
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    backgroundColor: "#ff9b54", // orange badge
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "22px",
                    fontWeight: "bold",
                    boxShadow: "0 6px 10px rgba(0,0,0,0.25)",
                  }}
                >
                  1
                </div>

                {/* Fixed image box */}
                <div style={{ height: "200px" }}>
                  <img
                    src={`/images/home/home1.jpg?refresh=${Date.now()}`}
                    alt="Step 1"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>

                <p style={{ fontSize: "18px", marginTop: "10px", whiteSpace: "pre-line" }}>
                  Create a Profile
                  {"\n"}Share your favorite
                  {"\n"}sports, skill level, and
                  {"\n"}availability.
                </p>
              </div>
              <div className="step-container text-center position-relative" style={{ width: "220px" }}>
                <div
                  style={{
                    position: "absolute",
                    top: "-30px",
                    left: "-30px",
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    backgroundColor: "#ff9b54", // orange badge
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "22px",
                    fontWeight: "bold",
                    boxShadow: "0 6px 10px rgba(0,0,0,0.25)",
                  }}
                >
                  2
                </div>

                <div style={{ height: "200px" }}>
                  <img
                    src={`/images/home/home2.jpg?refresh=${Date.now()}`}
                    alt="Step 2"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>

                <p style={{ fontSize: "18px", marginTop: "10px", whiteSpace: "pre-line" }}>
                  Get Matched
                  {"\n"}Paired with players
                  {"\n"}near you.
                </p>
              </div>

              <div className="step-container text-center position-relative" style={{ width: "220px" }}>
                <div
                  style={{
                    position: "absolute",
                    top: "-30px",
                    left: "-30px",
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    backgroundColor: "#ff9b54", // orange badge
                    color: "#fff",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontSize: "22px",
                    fontWeight: "bold",
                    boxShadow: "0 6px 10px rgba(0,0,0,0.25)",
                  }}
                >
                  3
                </div>

                <div style={{ height: "200px" }}>
                  <img
                    src={`/images/home/home3.jpg?refresh=${Date.now()}`}
                    alt="Step 3"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>

                <p style={{ fontSize: "18px", marginTop: "10px", whiteSpace: "pre-line" }}>
                  Play
                  {"\n"}Connect with people
                  {"\n"}through sports.
                </p>
              </div>
            </div>



          </div>


        </section>



        <section
          id="why-matchup"
          style={{
            ...sectionStyleAlt,
            padding: "50px 0",
            backgroundColor: "#9e4700ff", // Updated background
          }}
        >
          <div className="container-fluid px-3 px-md-5">
            <div className="row align-items-center">
              {/* Left Column - Image */}
              {/* Left Column - Image */}
              <div className="col-md-6 mb-4 mb-md-0">
                <img
                  src={`/images/home/home4.jpg?refresh=${Date.now()}`}
                  alt="Why MatchUp"
                  style={{
                    width: "100%",
                    height: "600px", // added fixed height
                    borderRadius: "16px",
                    objectFit: "cover",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                  }}
                />
              </div>


              {/* Right Column - Card with Text */}
              <div className="col-md-6">
                <div
                  className="card p-5"
                  style={{
                    borderRadius: "16px",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
                    backgroundColor: "#e67104ff",
                    color: "#fff", // sets default text color to white
                  }}
                >
                  <h2
                    className="h2 text-start"
                    style={{ fontSize: "100px", fontWeight: "900", color: "#fff" }}
                  >
                    Why use <br /> MatchUp?
                  </h2>
                  <p
                    className="text-start"
                    style={{
                      fontSize: "25px",
                      whiteSpace: "pre-line",
                      marginTop: "20px",
                      color: "#fff",
                    }}
                  >
                    Smart matchmaking for skill and schedule{"\n"}
                    Built-in event and game scheduling{"\n"}
                    Find new teammates and friends{"\n"}
                    Safe and active community
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>








        <section
          id="featured-sports"
          style={{
            ...sectionStyleAlt,
            padding: "50px 0",
            backgroundColor: "#9e4700ff", // Updated background
          }}
        >
          <div className="container-fluid px-3 px-md-5">


            <div className="row align-items-center">

              {/* Left Column - Headings & Text */}
              <div className="col-md-6 text-center text-md-start mb-4 mb-md-0">
                <h2
                  className="h2 text-start"
                  style={{ fontSize: "100px", fontWeight: "900", color: "#fff" }}
                >
                  Featured <br /> Sports
                </h2>
                <p
                  className="text-start"
                  style={{
                    fontSize: "25px",
                    whiteSpace: "pre-line",
                    marginTop: "20px",
                    color: "#fff",
                  }}
                >
                  Explore the most popular sports {"\n"}
                  played in your area! Whether you're {"\n"}
                  into team games or solo activities, {"\n"}
                  MatchUp highlights trending sports{"\n"}
                  to help you connect with others who {"\n"}
                  share your passion.
                </p>
              </div>

              {/* Right Column - Stacked Images */}
              {/* Right Column - Stacked Images with Labels */}
              <div className="col-md-6 d-flex flex-column gap-3">

                {/* Basketball */}
                <div className="position-relative" style={{ width: "100%", height: "200px", borderRadius: "10px", overflow: "hidden" }}>
                  <img
                    src="/images/home/basketball.jpg"
                    alt="Basketball"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "20px",
                      color: "#fff",
                      fontSize: "24px",
                      fontWeight: "bold",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
                    }}
                  >
                    Basketball
                  </span>
                </div>

                {/* Tennis */}
                <div className="position-relative" style={{ width: "100%", height: "200px", borderRadius: "10px", overflow: "hidden" }}>
                  <img
                    src="/images/home/tennis.jpg"
                    alt="Tennis"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "20px",
                      color: "#fff",
                      fontSize: "24px",
                      fontWeight: "bold",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
                    }}
                  >
                    Tennis
                  </span>
                </div>

                {/* Badminton */}
                <div className="position-relative" style={{ width: "100%", height: "200px", borderRadius: "10px", overflow: "hidden" }}>
                  <img
                    src="/images/home/badminton.jpg"
                    alt="Badminton"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "20px",
                      color: "#fff",
                      fontSize: "24px",
                      fontWeight: "bold",
                      textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
                    }}
                  >
                    Badminton
                  </span>
                </div>

              </div>




            </div>
          </div>
        </section>




        <section
          id="testimonials"
          style={{
            padding: "50px 0",
            backgroundColor: "#9e4700ff",
          }}
        >
          <div className="container-fluid px-3 px-md-5">
            {/* Responsive Heading */}
            <h2
              className="h2 text-center mb-5"
              style={{
                fontSize: "clamp(3rem, 8vw, 100px)",
                fontWeight: 900,
                color: "#fff",
              }}
            >
              Testimonials
            </h2>

            {/* Horizontal draggable container */}
            <div
              className="d-flex gap-4 overflow-auto justify-content-center"
              style={{
                cursor: "grab",
                flexWrap: "nowrap",
                paddingBottom: "10px",
                userSelect: "none",
              }}
              onMouseDown={(e) => {
                const slider = e.currentTarget;
                slider.isDown = true;
                slider.startX = e.pageX - slider.offsetLeft;
                slider.scrollLeftStart = slider.scrollLeft;
              }}
              onMouseUp={(e) => {
                const slider = e.currentTarget;
                slider.isDown = false;
                slider.startX = 0;
                slider.scrollLeftStart = 0;
              }}
              onMouseLeave={(e) => {
                const slider = e.currentTarget;
                slider.isDown = false;
                slider.startX = 0;
                slider.scrollLeftStart = 0;
              }}
              onMouseMove={(e) => {
                const slider = e.currentTarget;
                if (!slider.isDown) return;
                e.preventDefault();
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - slider.startX) * 2; // drag speed
                slider.scrollLeft = slider.scrollLeftStart + walk;
              }}
            >
              {rates.length > 0 ? (
                rates.map((rate, idx) => (
                  <div
                    key={idx}
                    className="position-relative text-center"
                    style={{
                      width: "300px",
                      maxWidth: "25vw",
                      flexShrink: 0,
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                    }}
                  >
                    {/* Background image */}
                    <img
                      src={`/images/home/testimonial.jpg?refresh=${Date.now()}`}
                      alt="testimonial"
                      style={{
                        width: "100%",
                        objectFit: "cover",
                      }}
                    />

                    {/* Overlay */}
                    <div
                      className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                      style={{
                        background: "rgba(0,0,0,0.5)",
                        color: "#fff",
                        padding: "15px",
                      }}
                    >
                      <div
                        style={{
                          overflowY: "auto", // scroll if too long
                          width: "100%",
                        }}
                      >
                        <p
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            marginBottom: "10px",
                            whiteSpace: "pre-wrap", // preserve line breaks
                            wordBreak: "break-word", // break long words
                          }}
                        >
                          {rate.comment}
                        </p>
                      </div>

                      <span style={{ fontSize: "14px" }}>⭐ {rate.rate} / 5</span>
                    </div>
                  </div>

                ))
              ) : (
                <p className="text-center text-white w-100">
                  No testimonials available yet.
                </p>
              )}
            </div>
          </div>
        </section>





      </div>

    </div >
  );
};

// Styles using only inline objects and Bootstrap spacing
const NAVBAR_HEIGHT = '80px';

const outerWrapperStyle = {
  margin: 0,
  padding: 0,
  overflowX: 'hidden',
  width: '100%',
};

const pageWrapperStyle = {
  marginTop: NAVBAR_HEIGHT,
  overflowX: 'hidden',
};

const sectionStyle = {
  minHeight: '100vh',
  padding: '60px 0',
  background: '#fff',
  scrollMarginTop: NAVBAR_HEIGHT,
};

const sectionStyleAlt = {
  ...sectionStyle,
  background: '#f1f1f1',
};

export default MainHomePage;
